// extracted by mini-css-extract-plugin
export default {"aboutUs":"about_aboutUs__mTDxB"};